var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContacts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.971 1.92136C9.00041 1.63819 6.99952 1.63819 5.02898 1.92136C4.05198 2.06175 3.29926 2.85467 3.20984 3.83764L3.12519 4.76813C2.92962 6.91798 2.92962 9.08115 3.12519 11.231L3.20984 12.1615C3.29926 13.1445 4.05198 13.9374 5.02898 14.0778C6.99952 14.3609 9.00041 14.3609 10.971 14.0778C11.9479 13.9374 12.7007 13.1445 12.7901 12.1615L12.8747 11.231C13.0703 9.08115 13.0703 6.91798 12.8747 4.76813L12.7901 3.83764C12.7007 2.85467 11.9479 2.06175 10.971 1.92136ZM6.66663 5.99957C6.66663 5.26319 7.26358 4.66624 7.99996 4.66624C8.73634 4.66624 9.33329 5.26319 9.33329 5.99957C9.33329 6.73595 8.73634 7.33291 7.99996 7.33291C7.26358 7.33291 6.66663 6.73595 6.66663 5.99957ZM5.33329 10.3329C5.33329 9.22834 6.22872 8.33291 7.33329 8.33291H8.66663C9.7712 8.33291 10.6666 9.22834 10.6666 10.3329C10.6666 10.7011 10.3681 10.9996 9.99996 10.9996H5.99996C5.63177 10.9996 5.33329 10.7011 5.33329 10.3329Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContacts);
export default __webpack_public_path__ + "static/media/contacts.70ed492292dd28a1a5155aba6975f494.svg";
export { ForwardRef as ReactComponent };